import { Text } from '@belong/ui';

type Props = {
  children: string;
  className?: string;
};

// todo: this could be a candidate to be moved to src/components. It could be used here, in FA, inspection lists and so on.
export function ErrorMessage({ children, className = '' }: Props) {
  return (
    <div className={className}>
      <Text className="text-red text-center" fontWeight="semibold" variant="p1">
        {children}
      </Text>
    </div>
  );
}
